import { Response } from 'miragejs';
import { StatusCodes as HTTP } from 'http-status-codes';

export default server => {
    server.get('/search/folders', schema => {
        const { models } = schema.searchFolders.all();

        return models;
    });

    server.get('/search/items', schema => {
        const { models } = schema.searchItems.all();

        return models;
    });

    server.post('/search/folders', (schema, { requestBody }) => {
        const { name, category, items } = JSON.parse(requestBody);

        const folder = schema.searchFolders.create({ name, category });

        for (const itemId of items) {
            schema.searchItems.find(itemId).update({ folderId: folder.attrs.id });
        }

        return folder.attrs;
    });

    server.post('/search/items', (schema, { requestBody }) => {
        const { name, category, folderId, logo_src, pinned, areAlertsEnabled } = JSON.parse(requestBody);

        const item = schema.searchItems.create({
            name,
            category,
            folderId,
            logo_src,
            pinned,
            areAlertsEnabled
        });

        return item.attrs;
    });

    server.put('/search/items/:id', (schema, { requestBody, params: { id } }) => {
        const { folderId } = JSON.parse(requestBody);

        const item = schema.searchItems.find(id);

        item.update({ folderId: folderId || undefined });

        return item.attrs;
    });

    server.put('/search/folders/:id', (schema, { params: { id }, requestBody }) => {
        const folder = schema.searchFolders.find(id);

        if (!folder) {
            return new Response(HTTP.NOT_FOUND);
        }

        const { name, items = [] } = JSON.parse(requestBody);

        const { models: modelItems } = schema.searchItems.where(item => item.folderId === folder.id);

        const removedItems = modelItems.filter(item => !items.includes(item.id));

        for (const item of removedItems) {
            item.update({ folderId: null });
        }

        for (const itemId of items) {
            schema.searchItems.find(itemId).update({
                folderId: folder.id
            });
        }

        folder.update({ name });

        return folder.attrs;
    });
    server.post('/search/items/:id/toggle-pin', (schema, { params: { id } }) => {
        const item = schema.searchItems.find(id);

        item.update({ pinned: !item.pinned });

        return { pinned: item.pinned };
    });

    server.post('/search/folders/:id/toggle-pin', (schema, { params: { id } }) => {
        const folder = schema.searchFolders.find(id);

        folder.update({ pinned: !folder.pinned });

        return { pinned: folder.pinned };
    });

    server.delete('/search/items/:id', (schema, { params: { id } }) => {
        const item = schema.searchItems.find(id);

        if (item) {
            item.destroy();
        }

        return new Response(HTTP.NO_CONTENT);
    });

    server.delete('/search/folders/:id', (schema, { params: { id } }) => {
        const folder = schema.searchFolders.find(id);

        if (folder) {
            folder.destroy();

            const { models: modelItems } = schema.searchItems.where(item => item.folderId === folder.id);

            for (const item of modelItems) {
                item.update({ folderId: null });
            }
        }

        return new Response(HTTP.NO_CONTENT);
    });
};
